import { fieldContainsValue } from "./helpers";

/**
 * API error text → user-friendly message mappings (single pattern).
 * @param {string} [error] - errorObj.data.error
 * @param {string} [message] - errorObj.data.message
 * @param {any} errorObj - Full error object (for string comparison)
 */
function mapToReadableMessage(error, message, errorObj) {
  let alertMessage = error || message;

  if (error?.includes("aadhar_number must be unique")) {
    alertMessage = "Aadhaar number must be unique. Please try with a different Aadhaar number.";
  } else if (error?.includes("driving_licence_number must be unique")) {
    alertMessage = "Driving licence number already exists. Please enter a unique licence number.";
  } else if (error?.includes("phone must be unique")) {
    alertMessage = "Driver phone number already exists.";
  } else if (message?.includes("Same vehicle present multiple times.")) {
    alertMessage = "This vehicle is already assigned";
  } else if (message?.includes("No driver exist with this id.")) {
    alertMessage = "No driver exist with this id.";
  } else if (message?.includes("There is already a pending request for recovery driver_id ")) {
    alertMessage = "There is already a pending request";
  } else if (message?.includes(" Does not Exist")) {
    alertMessage = "No car exist with this id.";
  } else if (message?.includes("Vehicle is not in rtd")) {
    alertMessage = "Vehicle is not in Ready To Deploy Status.";
  } else if (message?.includes("Already Vehicle Assigned to this driver.")) {
    alertMessage = "Already Vehicle Assigned to this driver.";
  } else if (error?.includes("pan_card must be unique")) {
    alertMessage = "Pan card number already exists.";
  } else if (error?.includes("not getting uber id")) {
    alertMessage = "Uber id required for this action ";
  } else if (error?.includes("Secondary Driver does not have a driver_uber_id")) {
    alertMessage = "Uber id required in secondary driver for this action";
  } else if (
    error?.includes("Secondary Driver not found. You need to add Secondary Driver for this Driver")
  ) {
    alertMessage = "Secondary Driver not found. You need to add Secondary Driver for this Driver";
  } else if (error?.includes("not getting uber id") || message?.includes("not getting uber id")) {
    alertMessage = "Uber id required";
  } else if (error?.includes('"driver_uber_id" must be a valid GUID')) {
    alertMessage = "Uber id must be a valid GUID";
  } else if (
    error?.includes("Odometer Reading Cannot be 0!") ||
    message?.includes("Odometer Reading Cannot be 0!") ||
    errorObj === "Odometer Reading Cannot be 0!"
  ) {
    alertMessage = "Odometer Reading Cannot be 0!";
  } else if (error?.includes("Driver not found On Uber Side In this Hub")) {
    alertMessage = "The driver was not found on Uber's site for this hub.";
  } else if (message?.includes("Body Parser failed")) {
    alertMessage = "Body Parser Failed.";
  } else if (
    message?.includes('"end_odometer" contains an invalid value') ||
    error?.includes('end_odometer" contains an invalid value')
  ) {
    alertMessage = "Odometer Reading Cannot be 0 in Receive";
  } else if (
    message?.includes("Unauthorized fields: end_odomete") ||
    error?.includes("Unauthorized fields: end_odomete")
  ) {
    alertMessage = "Odometer Reading Cannot be 0 in Receive";
  } else if (error?.includes("request already exists")) {
    alertMessage = "Request already exists please resolve it first.";
  } else if (
    (error?.includes("Vehicle with ID") && error?.includes("already assigned")) ||
    (message?.includes("Vehicle with ID") && message?.includes("already assigned"))
  ) {
    alertMessage =
      "Someone assign this car to another driver, this request will not process. Forgot this request forever.";
  } else if (
    (error?.includes("Secondary Driver not found You can") &&
      error?.includes("add Secondary Driver Also for this Driver")) ||
    (message?.includes("Secondary Driver not found You can") &&
      message?.includes("add Secondary Driver Also for this Driver"))
  ) {
    alertMessage =
      "Secondary Driver is not added for this car. Please contact the Hub Manager/Onboarding Agent to add the Secondary driver before processing this request.";
  } else if (
    (error?.includes("Failed to remove vehicle") && error?.includes("from Uber after")) ||
    (message?.includes("Failed to remove vehicle") && message?.includes("from Uber after"))
  ) {
    alertMessage = "Failed to Remove Vehicle from Uber after many Attempts";
  } else if (
    error?.includes("Driver is onboarded") ||
    message?.includes("Driver is onboarded. Transfer not possible.")
  ) {
    alertMessage = "Please remove vehicle from this driver then transfer hub.";
  } else if (
    error?.includes("vehicle is not rtd and rta status") ||
    message?.includes("vehicle is not rta and rtd status")
  ) {
    alertMessage = "Vehicle is not RTD or RTA status so it will not be transfer.";
  } else if (
    error?.includes("Scheme not found for driver 251611ab-3e63-4d5a-b7db-856053eefac4") ||
    message?.includes("Scheme not found for driver 251611ab-3e63-4d5a-b7db-856053eefac4")
  ) {
    alertMessage = "Scheme Required.";
  } else if (
    error?.includes("Driver and Vehicle Hub Mismatch") ||
    message?.includes("Driver and Vehicle Hub Mismatch") ||
    message?.includes("driver and vehicle hub mismatched") ||
    error?.includes("driver and vehicle hub mismatched") ||
    error?.includes("driver and vehicle hubId mismatched") ||
    message?.includes("driver and vehicle hubId mismatched")
  ) {
    alertMessage =
      "The driver and vehicle are not assigned to the same hub. Please shift the vehicle and driver to the same hub.";
  } else if (
    error?.includes(
      "Reonboarding request for this driver already exists or is pending/approved. Please check with your HM."
    ) ||
    message?.includes(
      "Reonboarding request for this driver already exists or is pending/approved. Please check with your HM."
    )
  ) {
    alertMessage =
      "Reonboarding request already exists or is pending/approved. Check with your HM.";
  } else if (
    error?.includes("settlement with this id not exists.") ||
    message?.includes("settlement with this id not exists.")
  ) {
    alertMessage = "Settlement data not found.";
  } else if (message?.includes("pending") || error?.includes("pending")) {
    alertMessage = "Request already exists, please resolve it first.";
  } else if (message?.includes("driver_id") || error?.includes("driver_id")) {
    alertMessage = "Driver is not available";
  } else if (message?.includes("vendor") || error?.includes("vendor")) {
    alertMessage = "Vendor is not available";
  } else if (message?.includes("server") || error?.includes("server")) {
    alertMessage = "An unexpected error occurred. Please try again.";
  } else if (message?.includes("vehicle_id") || error?.includes("vehicle_id")) {
    alertMessage = "Vehicle is not available.";
  } else if (message?.includes("Mapping")) {
    alertMessage = "Requested vehicle is not assigned to driver.";
  } else if (message?.includes("request_id")) {
    alertMessage = "No pending request exists. Either its already approved or rejected";
  } else if (message?.includes("invalid")) {
    alertMessage = "No pending request exists. Either its already approved or rejected.";
  } else if (message?.includes("overlapping with") || error?.includes("overlapping with")) {
    alertMessage = "overlapping with the applied waiver period";
  } else if (message?.includes("review_remarks") || error?.includes("review_remarks")) {
    alertMessage = "Please provide review remarks.";
  } else if (message?.includes("reject_reason") || error?.includes("reject_reason")) {
    alertMessage = "Please provide reject reason.";
  } else if (message?.includes("overlap") || error?.includes("overlap")) {
    alertMessage = "Week off already created for selected interval.";
  } else {
    alertMessage = `${error || message}`;
  }

  return alertMessage;
}

/**
 * Returns a user-friendly, mapped error message for API/error objects.
 * Uses the same mappings as the legacy controller (takeReadAbelError).
 * Use this when you want consistent, human-readable messages across the app.
 *
 * @param {any} errorObj - Error object (API response, Error, or string)
 * @param {string} [fallback='Something went wrong'] - Used when no message can be extracted
 * @returns {string} Always a string suitable for display (never an object)
 */
export function getReadableErrorMessage(errorObj, fallback = "Something went wrong") {
  if (errorObj == null) return fallback;
  if (typeof errorObj === "string") return errorObj.trim() || fallback;

  const data = errorObj?.data ?? errorObj?.response?.data;
  const error = data?.error ?? errorObj?.error;
  const message = data?.message ?? errorObj?.message;
  const statusCode = data?.statusCode ?? errorObj?.statusCode;

  if (!data && fieldContainsValue(errorObj) && !fieldContainsValue(errorObj?.message)) {
    return errorObj?.message ?? fallback;
  }

  const alertMessage = mapToReadableMessage(error, message, errorObj);

  if (fieldContainsValue(errorObj?.message)) {
    return errorObj?.message;
  }

  const final = statusCode ? `${statusCode} : ${alertMessage}` : alertMessage;
  if (final == null || String(final).trim() === "" || final === "undefined") {
    return fallback;
  }
  return final;
}
